export default __webpack_public_path__ + "static/images/2f77bfed.png";